import ReactOnRails from 'react-on-rails/client';
import EventsTable from '../../app/EventsTable.jsx';

ReactOnRails.register({EventsTable});